import { AddThemeContainer as AddTheme } from './AddThemeContainer'
// eslint-disable-next-line import/no-default-export
export default AddTheme
